import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, PhoneIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { business } from '../data/business';
import { heroImage } from '../data/gallery';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="home" className="relative isolate flex min-h-[88vh] items-center overflow-hidden" data-id="element-201" data-mp="4mi3tby6fqf0">
      <img src={heroImage} alt={t.hero.imageAlt} className="absolute inset-0 -z-20 h-full w-full object-cover" data-id="element-202" data-mp="129qvxpsonxpz" />
      <div className="absolute inset-0 -z-10" style={{
      background: 'linear-gradient(120deg, rgba(0, 31, 63, 0.82) 0%, rgba(0, 31, 63, 0.50) 45%, rgba(0, 102, 204, 0.45) 100%)'
    }} aria-hidden="true" data-id="element-203" data-mp="x8b9btauxj5h" />

      <div className="mx-auto w-full max-w-7xl px-4 py-24 sm:px-6 lg:px-8" data-id="element-204" data-mp="3d2l9jc5qb50p">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="max-w-3xl" data-id="element-205" data-mp="381xmt2oj9aca">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-brand-cyan" data-id="element-206" data-mp="3o7vktmez1ryc">
            {t.hero.eyebrow}
          </p>
          <h1 className="mt-4 font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-207" data-mp="39a36uyp2pbm9">
            {t.hero.title}
          </h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-white/85" data-id="element-208" data-mp="30gztsricb0s5">
            {t.hero.subtitle}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center" data-id="element-209" data-mp="35a2hwk4cli0y">
            <a href="#contact" className="inline-flex items-center justify-center rounded-lg bg-brand-orange px-7 py-4 text-base font-semibold text-white shadow-lift transition-colors duration-150 hover:bg-brand-orangeDark" data-id="element-210" data-mp="2ql68aimn7wy8">
              {t.hero.primaryCta}
            </a>
            <a href={business.phoneHref} className="inline-flex items-center justify-center gap-2 rounded-lg border-2 border-white/80 px-7 py-4 text-base font-semibold text-white transition-colors duration-150 hover:bg-white hover:text-navy" data-id="element-211" data-mp="2ljz1alsbr1sm">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-212" data-mp="icrpetr2yrat" />
              {t.hero.secondaryCta}
            </a>
          </div>

          <ul className="mt-10 flex flex-wrap gap-x-7 gap-y-3" data-id="element-213" data-mp="dbar95zzdixx">
            {t.hero.badges.map(badge => <li key={badge} className="flex items-center gap-2 text-sm font-medium text-white" data-id="element-214" data-mp="161t0korasgjs">
                <span className="flex h-5 w-5 items-center justify-center rounded-full bg-brand-cyan/25" data-id="element-215" data-mp="112pvj4bbiabt">
                  <CheckIcon className="h-3.5 w-3.5 text-brand-cyan" aria-hidden="true" data-id="element-216" data-mp="x1ee3m2lkvep" />
                </span>
                {badge}
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}